import { useEffect, useRef, useState } from "react";

import { getPositionFromSatrec } from "../../utils";
import { SpaceObjectType } from "../../types";
import dayjs from "dayjs";
import { useSpaceObjectStore } from "@graphic/stores";

type UseSpaceObjectProps = {
  data: SpaceObjectType;
  ref: React.MutableRefObject<THREE.Group | null>;
};

export const useSpaceObject = ({ data, ref }: UseSpaceObjectProps) => {
  const addObjectToStore = useSpaceObjectStore(state => state.add);

  const [object, setObject] = useState<SpaceObjectType>();

  useEffect(() => {
    if (!data || !ref.current) return;

    const object = initObject(data);
    const { uuid } = ref.current;

    setObject(object);
    addObjectToStore(object, uuid);
  }, [data, ref]);

  const initObject = (data: SpaceObjectType) => {
    const time = dayjs();

    const { satrec } = data;
    const position = getPositionFromSatrec(satrec, time);

    if (!position) return; // skip if position is null

    const noradId = Number(satrec.satnum);

    const object: SpaceObjectType = { ...data, noradId };

    return object;
  };

  return {
    object
  };
};

export default useSpaceObject;
